import { createAction } from 'redux/utils';
import { PP_ACTION_TYPES } from './product-platforms-types';
import { getProductPlatforms } from 'services/programs';

export const fetchPPsStart = () =>
    createAction(PP_ACTION_TYPES.FETCH_PRODUCT_PLATFORMS_START);

export const fetchPPsSuccess = (payload) =>
    createAction(PP_ACTION_TYPES.FETCH_PRODUCT_PLATFORMS_SUCCESS, payload);

export const fetchPPsFailed = (error) =>
    createAction(PP_ACTION_TYPES.FETCH_PRODUCT_PLATFORMS_FAILED, error);

export const fetchProductPlatformsAsync = async (dispatch) => {
    dispatch(fetchPPsStart());
    try {
        const productPlatforms = await getProductPlatforms();
        dispatch(fetchPPsSuccess(productPlatforms));
    } catch (error) {
        dispatch(fetchPPsFailed(error));
    }
};